import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  createWebHistory
} from 'vue-router'
import moment from 'moment'
import environment from '@/configs/environtment'
import Main from '@/views/layouts/Main.vue'
import DataTable from '@/views/pages/coba/UsingTable.vue'
import CustomList from '@/views/pages/coba/UsingCustomList.vue'
import RouteTable from '@/views/pages/master-setting/route/List.vue'
import RouteForm from '@/views/pages/master-setting/route/Form.vue'
import VehicleTable from '@/views/pages/master-setting/vehicle/Table.vue'
import PassengerList from '@/views/pages/master-setting/passenger-type/Table.vue'
import ClassList from '@/views/pages/master-setting/class/Table.vue'
import Login from '@/views/pages/auth/Login.vue'
import LoginHjex from '@/views/pages/auth/LoginHjex.vue'
import LoginSso from '@/views/pages/auth/LoginSso.vue'
import CityTerminal from '@/views/pages/master-setting/city-terminal/CityTerminal.vue'
import CityTerminalForm from '@/views/pages/master-setting/city-terminal/Form.vue'
import FixedExpensesForm from '@/views/pages/master-setting/expenses/fixed-expenses/Form.vue'
import ConstraintType from '@/views/pages/master-setting/constraint-type/Table.vue'
import TrayekList from '@/views/pages/master-setting/trayek/List2.vue'
import TrayekReserveList from '@/views/pages/master-setting/trayek/reserve/List.vue'
import TrayekTouristList from '@/views/pages/master-setting/trayek/tourist/List.vue'
import TrayekAirportList from '@/views/pages/master-setting/trayek/airport/List.vue'
import ConductorList from '@/views/pages/conductor/List.vue'
import ConductorForm from '@/views/pages/conductor/Form.vue'
import Price from '@/views/pages/master-setting/price/Price.vue'
import PriceDetail from '@/views/pages/master-setting/price/active-price/active-price-detail/ActivePriceDetail.vue'
import ListController from '@/views/pages/controller/List.vue'
import VerpalReport from '@/views/pages/verpal-report/VerpalReport.vue'
import VerpalDetail from '@/views/pages/verpal-report/VerpalDetail.vue'
import VerbalDetail from '@/views/pages/verbal-report/detail/VerbalDetail.vue'
import GlobalSetting from '@/views/pages/global-setting/GlobalSettings.vue'
import Reports from '@/views/pages/reports/index.vue'
import ReportsDetail from '@/views/pages/reports/detail/DetailReport.vue'
import ReportsAdvance from '@/views/pages/reports/detail/ListReportAdvance.vue'
import PlottingConductorList from '@/views/pages/plotting-conductor/Index.vue'
import DriverList from '@/views/pages/driver/List.vue'
import HelperList from '@/views/pages/helper/List.vue'
import RosterContinueForm from '@/views/pages/roster/airport/component/RosterContinueForm.vue'

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import store from '../store'

const TrayekForm = () => import('@/views/pages/master-setting/trayek/Form2.vue')
const TrayekMainList = () => import('@/views/pages/master-setting/trayek/main/List.vue')
const Expenses = () => import('@/views/pages/master-setting/expenses/Expenses.vue')
const RosterList = () => import('@/views/pages/roster/Index.vue')
const PariwisataRosterForm = () => import('@/views/pages/roster/form/AddRosterPariwisataForm.vue')
const PlottingConductorForm = () => import('@/views/pages/plotting-conductor/Form.vue')
const ListApproveDeposit = () => import('@/views/pages/approve-deposit/List.vue')
const ApprovalDepositDetail = () => import('@/views/pages/approve-deposit/Detail.vue')
const VerbalReport = () => import('@/views/pages/verbal-report/VerbalReport.vue')
const RosterAirportList = () => import('@/views/pages/roster/airport/Index.vue')

const baseRoute = '/hjp'
const checkUserInfo = () => {
  console.log('utXXX', localStorage.getItem('ut'))
  if (localStorage.getItem('userInfo')) {
    // const userInfo = JSON.parse(encryptDecriptMethods.decrypt(localStorage.getItem('userInfo')))
    const userInfo = localStorage.getItem('userInfo')
    console.log('zczxcz', userInfo)
  }
  if (localStorage.getItem('rn') === 'External') {
    console.log('aaa')
    return 'reports-advance'
  }
  if (localStorage.getItem('ut')) {
    return 'dashboard'
  }
  return ''
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    // eslint-disable-next-line consistent-return
    beforeEnter: async () => {
      // const ut = localStorage.getItem('ut')
      const ut = store.state.userProfile
      console.log('utx', ut)
      if (ut) {
        return `${baseRoute}/`
        // eslint-disable-next-line no-else-return
      } else {
        // console.log('environtment', environment.getHydraApi())
        // return 'hallo'
        // window.location.href = `${environment.getHydraApi()}oauth2/auth?client_id=${environment.getHydraClientId()}&scope=${environment.getHydraScope()}&response_type=${environment.getHydraResponseType()}&state=${environment.getHydraState()}&redirect_uri=${window.location.origin}/callback&login_uri=${window.location.origin}/login`
        return '/login'
      }
    },
    component: () => import('@/views/pages/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginSso,
    meta: {
      // this meta property is used to define that the route can acces when user don't have token access
      hideForAuth: true
    }
  },
  {
    path: '/logout-successful',
    name: 'Logout',
    beforeEnter: async () => {
      store.dispatch('logoutAccount')
      return '/login'
    },
    component: LoginSso,
    meta: {
      hideForAuth: true
    }
  },
  {
    path: '/login-hjex',
    name: 'Login-hjex',
    component: LoginHjex,
    meta: {
      hideForAuth: true
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/auth/ForgotPassword.vue')
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/pages/auth/ChangePassword.vue')
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/pages/auth/Callback.vue'),
    // meta: {
    //   // hideForAuth: true
    //   requiresAuth: true
    // }
  },
  {
    path: '/ticket/:id?',
    name: 'ticket',
    component: () => import('@/views/pages/ticket/index.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/pages/privacy-policy/privacy-policy.vue')
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: () => import('@/views/pages/privacy-policy/terms-condition.vue')
  },
  {
    path: `${baseRoute}`,
    // eslint-disable-next-line no-nested-ternary
    // redirect: `${baseRoute}/${localStorage.getItem('ut') === null ? '' : store.state.userProfile?.RolesName === 'External' ? 'reports' : 'dashboard'}`,
    redirect: `${baseRoute}/${checkUserInfo()}`,
    name: 'Main',
    component: Main,
    meta: {
      // this meta property is used to define that the route can acces when user have token access
      requiresAuth: true
    },
    children: [
      {
        path: 'table',
        name: 'Table',
        component: DataTable,
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/pages/dashboard/index.vue'),
        meta: {
          group: 'DASHBOARD',
          title: 'Dashboard',
        }
      },
      {
        path: 'unclosed-transaction-detail/:id?',
        name: 'unclosed-transaction-detail',
        component: () => import('@/views/pages/dashboard/components/UnclosedTransaction.vue'),
        meta: {
          group: 'DASHBOARD',
          title: 'Dashboard',
        }
      },
      {
        path: 'unclosed-transaction',
        name: 'unclosed-transaction',
        component: () => import('@/views/pages/dashboard/components/UnclosedTrayekTransaction.vue'),
        meta: {
          group: 'DASHBOARD',
          title: 'Dashboard',
        }
      },
      {
        path: 'departure-schedule',
        name: 'departure-schedule',
        component: () => import('@/views/pages/departure-schedule/DepartureSchedule.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Jadwal Keberangkatan'
        }
      },
      // plotting ditutup karena menunya digabung dengan roster
      // {
      //   path: 'plotting-conductor',
      //   name: 'plotting-conductor',
      //   component: PlottingConductorList,
      //   meta: {
      //     group: 'PLOTING KONDEKTUR',
      //     title: 'Ploting Kondektur'
      //   }
      // },
      // {
      //   path: 'plotting-conductor-form',
      //   name: 'plotting-conductor-form',
      //   component: PlottingConductorForm,
      //   meta: {
      //     group: 'PLOTING KONDEKTUR',
      //     title: 'Ploting Kondektur'
      //   }
      // },
      {
        path: 'roster',
        name: 'roster',
        component: RosterList,
        meta: {
          group: 'ROSTER',
          title: 'Roster'
        }
      },
      {
        path: 'tourist-roster-form',
        name: 'tourist-roster-form',
        component: PariwisataRosterForm,
        meta: {
          group: 'ROSTER',
          title: 'Roster'
        }
      },
      {
        path: 'roster-airport',
        name: 'roster-airport',
        component: RosterAirportList,
        meta: {
          group: 'ROSTER BANDARA',
          title: 'Roster Bandara'
        }
      },
      {
        path: 'roster-airport-form/:id?',
        name: 'roster-airport-form',
        component: RosterContinueForm,
        meta: {
          group: 'ROSTER BANDARA',
          title: 'Roster Bandara'
        }
      },
      {
        path: 'roster-snack/:id?',
        name: 'roster-snack',
        component: () => import('@/views/pages/roster/form/RosterSnackForm.vue'),
        meta: {
          group: 'ROSTER',
          title: 'Roster'
        }
      },
      {
        path: 'roster-snack-detail/:id?',
        name: 'roster-snack-detail',
        component: () => import('@/views/pages/roster/form/RosterSnackSummary.vue'),
        meta: {
          group: 'ROSTER',
          title: 'Roster'
        }
      },
      {
        path: 'master-setting-bank',
        name: 'master-bank',
        component: () => import('@/views/pages/master-setting/bank/Table.vue'),
        meta: {
          group: 'MASTER',
          title: 'Master Bank'
        }
      },
      // {
      //   path: 'master-setting-credential-bank',
      //   name: 'master-credential-bank',
      //   component: () => import('@/views/pages/master-setting/bank-credential/Table.vue'),
      //   meta: {
      //     group: 'MASTER',
      //     title: 'Master ID Credential Bank'
      //   }
      // },
      {
        path: 'master-setting-partner-agent',
        name: 'master-partner-agent',
        component: () => import('@/views/pages/master-setting/partner-agent/Table.vue'),
        meta: {
          group: 'MASTER',
          title: 'Master Mitra Agen'
        }
      },
      {
        path: 'master-route',
        name: 'master-route',
        component: RouteTable,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Rute'
        }
      },
      {
        path: 'master-route/form/:id?',
        name: 'master-route-form',
        component: RouteForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Rute'
        }
      },
      {
        path: 'master-vehicle',
        name: 'master-vehicle',
        component: VehicleTable,
        meta: {
          group: 'MASTER',
          title: 'Master Kendaraan'
        }
      },
      {
        path: 'master-passenger-type',
        name: 'master-passenger-type',
        component: PassengerList,
        meta: {
          group: 'MASTER',
          title: 'Master Jenis Penumpang'
        }
      },
      {
        path: 'master-class',
        name: 'master-class',
        component: ClassList,
        meta: {
          group: 'MASTER',
          title: 'Master Kelas'
        }
      },
      {
        path: 'master-city-terminal',
        name: 'master-city-terminal',
        component: CityTerminal,
        meta: {
          group: 'MASTER',
          title: 'Master Kota & Terminal'
        }
      },
      {
        path: 'master-city-terminal/form/:id?',
        name: 'master-city-terminal-form',
        component: CityTerminalForm,
        meta: {
          group: 'MASTER',
          title: 'Master Kota & Terminal'
        }
      },
      {
        path: 'master-fixed-expenses',
        name: 'master-fixed-expenses',
        component: Expenses,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Pengeluaran'
        }
      },
      {
        path: 'master-fixed-expenses/form/:id?',
        name: 'master-fixed-expenses-form',
        component: FixedExpensesForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Pengeluaran'
        }
      },
      {
        path: 'master-constraint-type',
        name: 'master-constraint-type',
        component: ConstraintType,
        meta: {
          group: 'MASTER',
          title: 'Master Jenis Kendala'
        }
      },
      {
        path: 'master-price',
        name: 'master-price',
        component: Price,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Harga & Komisi'
        }
      },
      {
        path: 'master-price/detail/:id?',
        name: 'master-price-detail',
        component: PriceDetail,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Harga & Komisi'
        }
      },
      {
        path: 'master-crew',
        name: 'master-crew',
        component: () => import('@/views/pages/master-setting/crew/Index.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Kru',
        }
      },
      {
        path: 'master-crew/detail/:id',
        name: 'master-crew-detail',
        component: () => import('@/views/pages/master-setting/crew/Detail.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Detail Kru',
        }
      },
      {
        path: 'master-mandoran-commission',
        name: 'master-mandoran-commission',
        component: () => import('@/views/pages/master-setting/mandoran-commission/Index.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Komisi Mandoran'
        }
      },
      {
        path: 'master-mandoran-commission/form/:id?',
        name: 'master-mandoran-commission-form',
        component: () => import('@/views/pages/master-setting/mandoran-commission/Form.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Komisi Mandoran'
        }
      },
      {
        path: 'master-trayek-main/form/:id?',
        name: 'master-trayek-main-form',
        component: TrayekForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Trayek'
        }
      },
      {
        path: 'master-trayek-reserve/form/:id?',
        name: 'master-trayek-reserve-form',
        component: TrayekForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Trayek'
        }
      },
      {
        path: 'master-trayek-tourist/form/:id?',
        name: 'master-trayek-tourist-form',
        component: TrayekForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Trayek'
        }
      },
      {
        path: 'master-trayek-airport/form/:id?',
        name: 'master-trayek-airport-form',
        component: TrayekForm,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Master Trayek'
        }
      },
      {
        path: 'master-trayek-main',
        name: 'master-trayek-main',
        component: TrayekMainList,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Trayek Utama'
        }
      },
      {
        path: 'master-trayek-reserve',
        name: 'master-trayek-reserve',
        component: TrayekReserveList,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Trayek Cadangan'
        }
      },
      {
        path: 'master-trayek-tourist',
        name: 'master-trayek-tourist',
        component: TrayekTouristList,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Trayek Pariwisata'
        }
      },
      {
        path: 'master-trayek-airport',
        name: 'master-trayek-airport',
        component: TrayekAirportList,
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Trayek Bandara'
        }
      },
      {
        path: 'conductor-account',
        name: 'conductor-account',
        component: ConductorList,
        meta: {
          group: 'KRU',
          title: 'Akun Kondektur'
        }
      },
      {
        path: 'conductor-account/form/:id?',
        name: 'conductor-account-form',
        component: ConductorForm,
        meta: {
          group: 'KRU',
          title: 'Akun Kondektur'
        }
      },
      {
        path: 'controller-account',
        name: 'controller-account',
        component: ListController,
        meta: {
          group: 'KRU',
          title: 'Akun Kontroller'
        }
      },
      {
        path: 'controller-account/form/:id?',
        name: 'controller-account-form',
        component: ConductorForm,
        meta: {
          group: 'KRU',
          title: 'Akun Kontroller'
        }
      },
      {
        path: 'driver-account',
        name: 'driver-account',
        component: DriverList,
        meta: {
          group: 'KRU',
          title: 'Akun Sopir'
        }
      },
      {
        path: 'driver-account/form/:id?',
        name: 'driver-account-form',
        component: ConductorForm,
        meta: {
          group: 'KRU',
          title: 'Akun Sopir'
        }
      },
      {
        path: 'helper-account',
        name: 'helper-account',
        component: HelperList,
        meta: {
          group: 'KRU',
          title: 'Akun Pembantu'
        }
      },
      {
        path: 'helper-account/form/:id?',
        name: 'helper-account-form',
        component: ConductorForm,
        meta: {
          group: 'KRU',
          title: 'Akun Pembantu'
        }
      },
      {
        path: 'approve-deposits',
        name: 'approve-deposits',
        component: ListApproveDeposit,
        meta: {
          group: 'TRANSAKSI',
          title: 'Approve Setoran'
        }
      },
      {
        path: 'approve-deposits/detail/:id',
        name: 'approve-deposits-detail',
        component: ApprovalDepositDetail,
        meta: {
          group: 'TRANSAKSI',
          title: 'Approve Setoran',
          activeMenu: 'approve-deposits'
        }
      },
      {
        path: 'approve-deposits/fueling-detail/:id',
        name: 'approve-deposits-fueling-detail',
        component: () => import('@/views/pages/approve-deposit/components/FuelingTransactionDetail.vue'),
        meta: {
          group: 'TRANSAKSI',
          title: 'Detail Transaksi',
          activeMenu: 'approve-deposits'
        }
      },
      {
        path: 'verpal-report',
        name: 'verpal-report',
        component: VerpalReport,
        meta: {
          group: 'TRANSAKSI',
          title: 'Verpal'
        }
      },
      {
        path: 'verpal-report/detail/:id',
        name: 'verpal-report-detail',
        component: VerpalDetail,
        meta: {
          group: 'TRANSAKSI',
          title: 'Verpal'
        }
      },
      {
        path: 'verbal-report',
        name: 'verbal-report',
        component: VerbalReport,
        meta: {
          group: 'TRANSAKSI',
          title: 'Verbal'
        }
      },
      {
        path: 'verbal-report/detail/:id',
        name: 'verbal-report-detail',
        component: VerbalDetail,
        meta: {
          group: 'TRANSAKSI',
          title: 'Verbal'
        }
      },
      {
        path: 'global-settings',
        name: 'global-settings',
        component: GlobalSetting,
        meta: {
          group: 'SETTINGS',
          title: 'Global Settings'
        }
      },
      {
        path: 'reports',
        name: 'reports',
        component: Reports,
        meta: {
          group: 'DASHBOARD',
          title: 'Laporan'
        }
      },
      {
        path: 'reports-advance',
        name: 'reports-advance',
        component: ReportsAdvance,
        meta: {
          group: 'DASHBOARD',
          title: 'Laporan'
        }
      },
      {
        path: 'tracking-bus',
        name: 'tracking-bus',
        component: () => import('@/views/pages/tracking-bus/index.vue'),
        meta: {
          group: 'TRACKING BUS',
          title: 'Tracking Bus',
        }
      },
      {
        path: 'cashless-closed-deposits',
        name: 'cashless-closed-deposits',
        component: () => import('@/views/pages/cashless-closed-deposit/Index.vue'),
        meta: {
          group: 'CLOSING SETORAN',
          title: 'Closing Setoran',
        }
      },
      {
        path: 'cashless-closed-deposits/detail/:id?',
        name: 'cashless-closed-deposits-detail',
        component: () => import('@/views/pages/cashless-closed-deposit/components/Detail.vue'),
        meta: {
          group: 'CLOSING SETORAN',
          title: 'Closing Setoran',
        }
      },
      {
        path: 'dashboard-roster',
        name: 'dashboard-roster',
        component: () => import('@/views/pages/dashboard/DashboardRoster.vue'),
        meta: {
          group: 'DASHBOARD ROSTER',
          title: 'Dashboard Roster ',
        }
      },
      {
        path: 'helpdesk',
        name: 'helpdesk',
        component: () => import('@/views/pages/helpdesk/Index.vue'),
        meta: {
          group: 'SUPPORT',
          title: 'Support ',
        }
      },
      {
        path: 'helpdesk/detail/:id',
        name: 'helpdesk-detail',
        component: () => import('@/views/pages/helpdesk/Detail.vue'),
        meta: {
          group: 'SUPPORT',
          title: 'Support ',
        }
      },
      {
        path: 'ticket-subscription',
        name: 'ticket-subscription',
        component: () => import('@/views/pages/ticket-subscription/Index.vue'),
        meta: {
          group: 'KARCIS LANGGANAN',
          title: 'Tiket Langganan'
        }
      },
      {
        path: 'ticket-subscription/form/:id?',
        name: 'ticket-subscription-form',
        component: () => import('@/views/pages/ticket-subscription/forms/Form.vue'),
        meta: {
          group: 'PERSIAPAN KEBERANGKATAN',
          title: 'Tiket Langganan'
        }
      },
      {
        path: 'master-partner',
        name: 'master-partner',
        component: () => import('@/views/pages/externals/partner/Index.vue'),
        meta: {
          group: 'EKSTERNAL',
          title: 'Master Partner'
        }
      },
      {
        path: 'partner-agreement/:id?',
        name: 'partner-agreement',
        component: () => import('@/views/pages/externals/contract/ListContract.vue'),
        meta: {
          group: 'EKSTERNAL',
          title: 'Master Partner',
          activeMenu: 'master-partner'
        }
      },
      {
        path: 'partner-agreement/:partnerId?/form/:id?',
        name: 'partner-agreement-form',
        component: () => import('@/views/pages/externals/contract/Form.vue'),
        meta: {
          group: 'EKSTERNAL',
          title: 'Master Partner',
          activeMenu: 'master-partner'
        }
      },
      {
        path: 'master-snack',
        name: 'master-snack',
        component: () => import('@/views/pages/master-setting/snack/Index.vue'),
        meta: {
          group: 'MASTER BUNDLE SNACK',
          title: 'Master Bundle Snack'
        }
      },
      {
        path: 'approve-snack',
        name: 'approve-snack',
        component: () => import('@/views/pages/approve-snack-roster/Index.vue'),
        meta: {
          group: 'CLOSING SNACK',
          title: 'Closing Snack'
        }
      },
      {
        path: 'approve-snack-detail/:id?',
        name: 'approve-snack-detail',
        component: () => import('@/views/pages/approve-snack-roster/Detail.vue'),
        meta: {
          group: 'CLOSING SNACK',
          title: 'Closing Snack'
        }
      },
      {
        path: 'master-spbu',
        name: 'master-spbu',
        component: () => import('@/views/pages/master-setting/spbu/Index.vue'),
        meta: {
          group: 'MASTER PARTNER SPBU',
          title: 'Master Partner SPBU'
        }
      },
      {
        path: 'master-spbu/form/:id?',
        name: 'master-spbu-form',
        component: () => import('@/views/pages/master-setting/spbu/Form.vue'),
        meta: {
          group: 'MASTER PARTNER SPBU',
          title: 'Master Partner SPBU'
        }
      },
      {
        path: 'master-spbu/fuel/form/:id?',
        name: 'master-spbu-fuel-form',
        component: () => import('@/views/pages/master-setting/spbu/FuelPriceForm.vue'),
        meta: {
          group: 'MASTER PARTNER SPBU',
          title: 'Master Partner SPBU'
        }
      },
      {
        path: 'master-fuel-coupon',
        name: 'master-fuel-coupon',
        component: () => import('@/views/pages/master-setting/fuel-coupon/Index.vue'),
        meta: {
          group: 'KUPON BBM',
          title: 'Kupon BBM'
        }
      },
      {
        path: 'master-fuel-coupon/form/:id?',
        name: 'master-fuel-coupon-form',
        component: () => import('@/views/pages/master-setting/fuel-coupon/Form.vue'),
        meta: {
          group: 'KUPON BBM',
          title: 'Kupon BBM'
        }
      },
      {
        path: 'fuel-payment-batch',
        name: 'fuel-payment-batch',
        component: () => import('@/views/pages/externals/fuel/fuel-payment-batch/Index.vue'),
        meta: {
          group: 'BATCH PEMBAYARAN BBM',
          title: 'Batch Pembayaran BBM'
        }
      },
      {
        path: 'fuel-payment-batch-detail/:id?',
        name: 'fuel-payment-batch-detail',
        component: () => import('@/views/pages/externals/fuel/fuel-payment-batch/pages/Detail.vue'),
        meta: {
          group: 'BATCH PEMBAYARAN BBM',
          title: 'Batch Pembayaran BBM'
        }
      },
      {
        path: 'fuel-payment-batch-transaction-detail/:id?',
        name: 'fuel-payment-batch-transaction-detail',
        component: () => import('@/views/pages/externals/fuel/fuel-payment-batch/pages/TransactionDetail.vue'),
        meta: {
          group: 'BATCH PEMBAYARAN BBM',
          title: 'Detail Transaksi BBM'
        }
      },
      {
        path: 'fuel-monitoring',
        name: 'fuel-monitoring',
        component: () => import('@/views/pages/externals/fuel-monitoring/Index.vue'),
        meta: {
          group: 'MONITORING TRANSAKSI',
          title: 'Monitoring Transaksi'
        }
      },
      {
        path: 'fuel-monitoring-detail/:id?',
        name: 'fuel-monitoring-detail',
        component: () => import('@/views/pages/externals/fuel-monitoring/Detail.vue'),
        meta: {
          group: 'MONITORING TRANSAKSI',
          title: 'Detail Transaksi'
        }
      },
      {
        path: 'master-mandoran',
        name: 'master-mandoran',
        component: () => import('@/views/pages/master-setting/mandoran/Index.vue'),
        meta: {
          group: 'MASTER MANDORAN',
          title: 'Master Mandoran'
        }
      },
      {
        path: 'master-mandoran/form/:id?',
        name: 'master-mandoran-form',
        component: () => import('@/views/pages/master-setting/mandoran/Form.vue'),
        meta: {
          group: 'MASTER MANDORAN',
          title: 'Master Mandoran'
        }
      },
      {
        path: 'master-mandoran/transaction-history/:id?',
        name: 'master-mandoran-transaction-history',
        component: () => import('@/views/pages/master-setting/mandoran/TransactionHistory.vue'),
        meta: {
          group: 'MASTER MANDORAN',
          title: 'Master Mandoran'
        }
      },
      {
        path: 'master-mandoran-commission/detail/:id?',
        name: 'master-mandoran-commission-detail',
        component: () => import('@/views/pages/master-setting/mandoran/ComissionDetail.vue'),
        meta: {
          group: 'MASTER MANDORAN',
          title: 'Master Mandoran'
        }
      },
    ]
  },
  {
    path: '/reports/detail/:typeReport',
    name: 'reports-detail',
    component: ReportsDetail,
    meta: {
      group: 'DASHBOARD',
      title: 'Laporan'
    }
  },
  {
    path: '/xxx',
    name: 'xx',
    component: () => import('@/views/shared-components/xxx.vue'),
    meta: {
      group: 'DASHBOARD',
      title: 'Laporan'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

const checkDateExpired = (): boolean => {
  const token = localStorage.getItem('ut')
  const timeExpired = Number(localStorage.getItem('ei'))
  console.log('dateExpiredX', [token, timeExpired])
  if (token && timeExpired) {
    if (timeExpired > 0) {
      return true
    }
    // const now = moment()
    // const checkHours = moment.duration(now.diff(timeExpired)).asHours()
    // if (checkHours <= 48) {
    //   return true
    // }
  }
  console.log('dateExpired')
  // store.dispatch('logoutAccount')

  return false
}

router.beforeEach((to, from, next) => {
  store.dispatch('hideLoading')
  const fuelBatchRoutes = [
    'fuel-payment-batch',
    'fuel-payment-batch-detail',
    'fuel-payment-batch-transaction-detail'
  ]
  if (to.name === 'fuel-payment-batch' && !fuelBatchRoutes.includes(String(from.name))) {
    sessionStorage.removeItem('fuel-payment-batch-tab-position')
    store.dispatch('setTabPosition', 0)
  }
  const token = localStorage.getItem('ut')
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (checkDateExpired()) {
      if (token) {
        next()
      } else {
        next({ name: 'Home' })
      }
    } else {
      next({ name: 'Home' })
    }
  } else if (to.matched.some((record) => record.meta.hideForAuth)) {
    // if the user have token then he can access
    if (checkDateExpired()) {
      if (token) {
        next({ name: 'dashboard' })
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
